import assets from 'assets/icons/sprites.svg';

interface IconProps {
	name: string;
	color?: string;
	width?: number;
	height?: number;
	style?: React.CSSProperties;
}

function Icon({ name, color, style, width = 20, height = 20 }: IconProps) {
	return (
		<svg style={{ fill: color ? color : undefined, minWidth: width, maxWidth: width, height: height, ...style }}>
			<use href={assets + '#' + name}></use>
		</svg>
	);
}

export default Icon;
